// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type OptionsLegacyParser,
  formDataBodySerializer,
  urlSearchParamsBodySerializer,
} from "@hey-api/client-axios";
import type {
  DbHealthError,
  DbHealthResponse,
  RunSqlQueryData,
  RunSqlQueryError,
  RunSqlQueryResponse,
  GetTableInfoError,
  GetTableInfoResponse,
  NewMessageData,
  NewMessageError,
  NewMessageResponse,
  NewMessageStreamingData,
  NewMessageStreamingError,
  NewMessageStreamingResponse,
  HealthError,
  HealthResponse,
  WeaviateHealthData,
  WeaviateHealthError,
  WeaviateHealthResponse,
  WeaviateInfoData,
  WeaviateInfoError,
  WeaviateInfoResponse,
  WeaviateIndexesData,
  WeaviateIndexesError,
  WeaviateIndexesResponse,
  WeaviateIndexExistData,
  WeaviateIndexExistError,
  WeaviateIndexExistResponse,
  WeaviateCreateIndexData,
  WeaviateCreateIndexError,
  WeaviateCreateIndexResponse,
  WeaviateDeleteIndexData,
  WeaviateDeleteIndexError,
  WeaviateDeleteIndexResponse,
  WeaviateGetIndexCountData,
  WeaviateGetIndexCountError,
  WeaviateGetIndexCountResponse,
  WeaviateSearchIndexData,
  WeaviateSearchIndexError,
  WeaviateSearchIndexResponse,
  WeaviateUpsertIndexData,
  WeaviateUpsertIndexError,
  WeaviateUpsertIndexResponse,
  GetKpiData,
  GetKpiError,
  GetKpiResponse,
  GetSummaryData,
  GetSummaryError,
  GetSummaryResponse,
  GetGrossProfitByPeriodData,
  GetGrossProfitByPeriodError,
  GetGrossProfitByPeriodResponse,
  GetGrossProfitPerRegionData,
  GetGrossProfitPerRegionError,
  GetGrossProfitPerRegionResponse,
  GetGrossProfitTrendData,
  GetGrossProfitTrendError,
  GetGrossProfitTrendResponse,
  GetSeasonalSalesProfitData,
  GetSeasonalSalesProfitError,
  GetSeasonalSalesProfitResponse,
  GetRevenuePerPeriodData,
  GetRevenuePerPeriodError,
  GetRevenuePerPeriodResponse,
  GetReclameCostPerPeriodData,
  GetReclameCostPerPeriodError,
  GetReclameCostPerPeriodResponse,
  GetSalesForecastData,
  GetSalesForecastError,
  GetSalesForecastResponse,
  GetShellKpisData,
  GetShellKpisError,
  GetShellKpisResponse,
  RunRegressionData,
  RunRegressionError,
  RunRegressionResponse,
  GetFilterOptionsData,
  GetFilterOptionsError,
  GetFilterOptionsResponse,
  GetPromptLibraryError,
  GetPromptLibraryResponse,
  CreatePromptData,
  CreatePromptError,
  CreatePromptResponse,
  GetConversationsError,
  GetConversationsResponse,
  GetEventsData,
  GetEventsError,
  GetEventsResponse,
  GetPreviewData,
  GetPreviewError,
  GetPreviewResponse,
  GetDatasourcesError,
  GetDatasourcesResponse,
  GetDatasourceByIdData,
  GetDatasourceByIdError,
  GetDatasourceByIdResponse,
  UpdateDatasourceData,
  UpdateDatasourceError,
  UpdateDatasourceResponse,
  CreateDatasourceData,
  CreateDatasourceError,
  CreateDatasourceResponse,
  UsersCurrentUserError,
  UsersCurrentUserResponse,
  UsersPatchCurrentUserData,
  UsersPatchCurrentUserError,
  UsersPatchCurrentUserResponse,
  UsersUserData,
  UsersUserError,
  UsersUserResponse,
  UsersPatchUserData,
  UsersPatchUserError,
  UsersPatchUserResponse,
  UsersDeleteUserData,
  UsersDeleteUserError,
  UsersDeleteUserResponse,
  AuthJwtLoginData,
  AuthJwtLoginError,
  AuthJwtLoginResponse,
  AuthJwtLogoutError,
  AuthJwtLogoutResponse,
  RegisterRegisterData,
  RegisterRegisterError,
  RegisterRegisterResponse,
  ResetForgotPasswordData,
  ResetForgotPasswordError,
  ResetForgotPasswordResponse,
  ResetResetPasswordData,
  ResetResetPasswordError,
  ResetResetPasswordResponse,
  VerifyRequestTokenError,
  VerifyRequestTokenResponse,
  VerifyVerifyData,
  VerifyVerifyError,
  VerifyVerifyResponse,
  GetOrganizationsError,
  GetOrganizationsResponse,
  CreateOrganizationData,
  CreateOrganizationError,
  CreateOrganizationResponse,
  GetOrganizationData,
  GetOrganizationError,
  GetOrganizationResponse,
  GetOrganizationUsersData,
  GetOrganizationUsersError,
  GetOrganizationUsersResponse,
  CreateUserForOrganizationData,
  CreateUserForOrganizationError,
  CreateUserForOrganizationResponse,
  GetOrganizationDepartmentsData,
  GetOrganizationDepartmentsError,
  GetOrganizationDepartmentsResponse,
  CreateDepartmentData,
  CreateDepartmentError,
  CreateDepartmentResponse,
  UpdateDepartmentData,
  UpdateDepartmentError,
  UpdateDepartmentResponse,
  RemoveUserFromOrganizationData,
  RemoveUserFromOrganizationError,
  RemoveUserFromOrganizationResponse,
  UpdateUserInOrganizationData,
  UpdateUserInOrganizationError,
  UpdateUserInOrganizationResponse,
  InviteUserToOrganizationByEmailData,
  InviteUserToOrganizationByEmailError,
  InviteUserToOrganizationByEmailResponse,
  AcceptInviteUserToOrganizationData,
  AcceptInviteUserToOrganizationError,
  AcceptInviteUserToOrganizationResponse,
  DeclineInviteUserToOrganizationData,
  DeclineInviteUserToOrganizationError,
  DeclineInviteUserToOrganizationResponse,
  GetAirbusDataData,
  GetAirbusDataError,
  GetAirbusDataResponse,
  GetAirbusGraphsData,
  GetAirbusGraphsError,
  GetAirbusGraphsResponse,
} from "./types.gen";

export const client = createClient(createConfig());

/**
 * Db Health
 * Check if the postgres database is up and running.
 */
export const dbHealth = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    DbHealthResponse,
    DbHealthError,
    ThrowOnError
  >({
    ...options,
    url: "/db/health",
  });
};

/**
 * Run Sql Query
 * Run an SQL query on a table.
 */
export const runSqlQuery = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<RunSqlQueryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    RunSqlQueryResponse,
    RunSqlQueryError,
    ThrowOnError
  >({
    ...options,
    url: "/db/run/sql/{table_name}/{query}",
  });
};

/**
 * Get Table Info
 * Get table information from SQL database.
 */
export const getTableInfo = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTableInfoResponse,
    GetTableInfoError,
    ThrowOnError
  >({
    ...options,
    url: "/langchain/db/info",
  });
};

/**
 * New Message
 */
export const newMessage = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<NewMessageData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    NewMessageResponse,
    NewMessageError,
    ThrowOnError
  >({
    ...options,
    url: "/message",
  });
};

/**
 * New Message Streaming
 */
export const newMessageStreaming = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<NewMessageStreamingData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    NewMessageStreamingResponse,
    NewMessageStreamingError,
    ThrowOnError
  >({
    ...options,
    url: "/message/stream",
  });
};

/**
 * Health
 */
export const health = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    HealthResponse,
    HealthError,
    ThrowOnError
  >({
    ...options,
    url: "/health",
  });
};

/**
 * Weaviate Health
 * Check the health status of the Weaviate instance.
 */
export const weaviateHealth = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateHealthData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    WeaviateHealthResponse,
    WeaviateHealthError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/health",
  });
};

/**
 * Weaviate Info
 * Get the info of the Weaviate instance.
 */
export const weaviateInfo = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateInfoData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    WeaviateInfoResponse,
    WeaviateInfoError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/info",
  });
};

/**
 * Weaviate Indexes
 * Get a list of all active indexes in Weaviate.
 */
export const weaviateIndexes = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateIndexesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    WeaviateIndexesResponse,
    WeaviateIndexesError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/indexes",
  });
};

/**
 * Weaviate Index Exist
 * Check if an index exists in Weaviate.
 */
export const weaviateIndexExist = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateIndexExistData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    WeaviateIndexExistResponse,
    WeaviateIndexExistError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/index/{index_name}",
  });
};

/**
 * Weaviate Create Index
 * Create a new index in Weaviate.
 */
export const weaviateCreateIndex = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateCreateIndexData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    WeaviateCreateIndexResponse,
    WeaviateCreateIndexError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/index/{index_name}",
  });
};

/**
 * Weaviate Delete Index
 * Delete an index from Weaviate.
 */
export const weaviateDeleteIndex = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateDeleteIndexData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    WeaviateDeleteIndexResponse,
    WeaviateDeleteIndexError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/index/{index_name}",
  });
};

/**
 * Weaviate Get Index Count
 * Get the count of objects in an index in Weaviate.
 */
export const weaviateGetIndexCount = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateGetIndexCountData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    WeaviateGetIndexCountResponse,
    WeaviateGetIndexCountError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/index/{index_name}/count",
  });
};

/**
 * Weaviate Search Index
 * Search an index in Weaviate.
 */
export const weaviateSearchIndex = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateSearchIndexData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    WeaviateSearchIndexResponse,
    WeaviateSearchIndexError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/index/{index_name}/search",
  });
};

/**
 * Weaviate Upsert Index
 * Upsert data to an index in Weaviate.
 */
export const weaviateUpsertIndex = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<WeaviateUpsertIndexData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    WeaviateUpsertIndexResponse,
    WeaviateUpsertIndexError,
    ThrowOnError
  >({
    ...options,
    url: "/weaviate/index/{index_name}/upsert",
  });
};

/**
 * Get Kpi
 */
export const getKpi = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetKpiData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetKpiResponse,
    GetKpiError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/kpi",
  });
};

/**
 * Get Summary
 */
export const getSummary = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetSummaryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSummaryResponse,
    GetSummaryError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/summary",
  });
};

/**
 * Get Gross Profit By Period
 */
export const getGrossProfitByPeriod = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetGrossProfitByPeriodData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetGrossProfitByPeriodResponse,
    GetGrossProfitByPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/gross-profit-by-period",
  });
};

/**
 * Get Gross Profit Per Region
 */
export const getGrossProfitPerRegion = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetGrossProfitPerRegionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetGrossProfitPerRegionResponse,
    GetGrossProfitPerRegionError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/gross-profit-per-region",
  });
};

/**
 * Get Gross Profit Trend
 */
export const getGrossProfitTrend = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetGrossProfitTrendData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetGrossProfitTrendResponse,
    GetGrossProfitTrendError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/gross-profit-trend",
  });
};

/**
 * Get Seasonal Sales Profit
 */
export const getSeasonalSalesProfit = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetSeasonalSalesProfitData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetSeasonalSalesProfitResponse,
    GetSeasonalSalesProfitError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/seasonal-sales-profit",
  });
};

/**
 * Get Revenue Per Period
 */
export const getRevenuePerPeriod = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetRevenuePerPeriodData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetRevenuePerPeriodResponse,
    GetRevenuePerPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/revenue-per-period",
  });
};

/**
 * Get Reclame Cost Per Period
 */
export const getReclameCostPerPeriod = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetReclameCostPerPeriodData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetReclameCostPerPeriodResponse,
    GetReclameCostPerPeriodError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/reclame-kost-per-period",
  });
};

/**
 * Get Sales Forecast
 */
export const getSalesForecast = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetSalesForecastData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetSalesForecastResponse,
    GetSalesForecastError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/sales-forecast",
  });
};

/**
 * Get Shell Kpis
 */
export const getShellKpis = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetShellKpisData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetShellKpisResponse,
    GetShellKpisError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/shell/kpi",
  });
};

/**
 * Run Regression
 */
export const runRegression = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<RunRegressionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RunRegressionResponse,
    RunRegressionError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/shell/regression",
  });
};

/**
 * Get Filter Options
 */
export const getFilterOptions = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetFilterOptionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetFilterOptionsResponse,
    GetFilterOptionsError,
    ThrowOnError
  >({
    ...options,
    url: "/bi/shell/filters",
  });
};

/**
 * Get Prompt Library
 */
export const getPromptLibrary = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPromptLibraryResponse,
    GetPromptLibraryError,
    ThrowOnError
  >({
    ...options,
    url: "/tracker/prompt-library",
  });
};

/**
 * Create Prompt
 */
export const createPrompt = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreatePromptData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreatePromptResponse,
    CreatePromptError,
    ThrowOnError
  >({
    ...options,
    url: "/tracker/prompt-library",
  });
};

/**
 * Get Conversations
 */
export const getConversations = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetConversationsResponse,
    GetConversationsError,
    ThrowOnError
  >({
    ...options,
    url: "/tracker/conversation",
  });
};

/**
 * Get Events
 */
export const getEvents = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetEventsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetEventsResponse,
    GetEventsError,
    ThrowOnError
  >({
    ...options,
    url: "/tracker/conversation/{conversation_id}",
  });
};

/**
 * Get Preview
 */
export const getPreview = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetPreviewData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetPreviewResponse,
    GetPreviewError,
    ThrowOnError
  >({
    ...options,
    url: "/datasources/preview/{datasource_name}",
  });
};

/**
 * Get Datasources
 */
export const getDatasources = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetDatasourcesResponse,
    GetDatasourcesError,
    ThrowOnError
  >({
    ...options,
    url: "/datasources",
  });
};

/**
 * Get Datasource By Id
 */
export const getDatasourceById = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetDatasourceByIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetDatasourceByIdResponse,
    GetDatasourceByIdError,
    ThrowOnError
  >({
    ...options,
    url: "/datasources/{datasource_Id}",
  });
};

/**
 * Update Datasource
 */
export const updateDatasource = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateDatasourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateDatasourceResponse,
    UpdateDatasourceError,
    ThrowOnError
  >({
    ...options,
    url: "/datasources/{datasource_id}",
  });
};

/**
 * Create Datasource
 * Uploads a CSV or Excel file to the database while streaming large data.
 */
export const createDatasource = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateDatasourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDatasourceResponse,
    CreateDatasourceError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
    url: "/datasources/",
  });
};

/**
 * Users:Current User
 */
export const usersCurrentUser = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    UsersCurrentUserResponse,
    UsersCurrentUserError,
    ThrowOnError
  >({
    ...options,
    url: "/user/me",
  });
};

/**
 * Users:Patch Current User
 */
export const usersPatchCurrentUser = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UsersPatchCurrentUserData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UsersPatchCurrentUserResponse,
    UsersPatchCurrentUserError,
    ThrowOnError
  >({
    ...options,
    url: "/user/me",
  });
};

/**
 * Users:User
 */
export const usersUser = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UsersUserData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    UsersUserResponse,
    UsersUserError,
    ThrowOnError
  >({
    ...options,
    url: "/user/{id}",
  });
};

/**
 * Users:Patch User
 */
export const usersPatchUser = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UsersPatchUserData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UsersPatchUserResponse,
    UsersPatchUserError,
    ThrowOnError
  >({
    ...options,
    url: "/user/{id}",
  });
};

/**
 * Users:Delete User
 */
export const usersDeleteUser = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UsersDeleteUserData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    UsersDeleteUserResponse,
    UsersDeleteUserError,
    ThrowOnError
  >({
    ...options,
    url: "/user/{id}",
  });
};

/**
 * Auth:Jwt.Login
 */
export const authJwtLogin = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<AuthJwtLoginData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AuthJwtLoginResponse,
    AuthJwtLoginError,
    ThrowOnError
  >({
    ...options,
    ...urlSearchParamsBodySerializer,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      ...options?.headers,
    },
    url: "/auth/jwt/login",
  });
};

/**
 * Auth:Jwt.Logout
 */
export const authJwtLogout = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AuthJwtLogoutResponse,
    AuthJwtLogoutError,
    ThrowOnError
  >({
    ...options,
    url: "/auth/jwt/logout",
  });
};

/**
 * Register:Register
 */
export const registerRegister = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<RegisterRegisterData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RegisterRegisterResponse,
    RegisterRegisterError,
    ThrowOnError
  >({
    ...options,
    url: "/auth/register",
  });
};

/**
 * Reset:Forgot Password
 */
export const resetForgotPassword = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<ResetForgotPasswordData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ResetForgotPasswordResponse,
    ResetForgotPasswordError,
    ThrowOnError
  >({
    ...options,
    url: "/auth/forgot-password",
  });
};

/**
 * Reset:Reset Password
 */
export const resetResetPassword = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<ResetResetPasswordData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ResetResetPasswordResponse,
    ResetResetPasswordError,
    ThrowOnError
  >({
    ...options,
    url: "/auth/reset-password",
  });
};

/**
 * Verify:Request-Token
 */
export const verifyRequestToken = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    VerifyRequestTokenResponse,
    VerifyRequestTokenError,
    ThrowOnError
  >({
    ...options,
    url: "/auth/request-verify-token",
  });
};

/**
 * Verify:Verify
 */
export const verifyVerify = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<VerifyVerifyData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    VerifyVerifyResponse,
    VerifyVerifyError,
    ThrowOnError
  >({
    ...options,
    url: "/auth/verify",
  });
};

/**
 * Get Organizations
 */
export const getOrganizations = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationsResponse,
    GetOrganizationsError,
    ThrowOnError
  >({
    ...options,
    url: "/organization",
  });
};

/**
 * Create Organization
 */
export const createOrganization = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateOrganizationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateOrganizationResponse,
    CreateOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: "/organization",
  });
};

/**
 * Get Organization
 */
export const getOrganization = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetOrganizationData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationResponse,
    GetOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}",
  });
};

/**
 * Get Organization Users
 */
export const getOrganizationUsers = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<GetOrganizationUsersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationUsersResponse,
    GetOrganizationUsersError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/user",
  });
};

/**
 * Create User For Organization
 */
export const createUserForOrganization = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateUserForOrganizationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateUserForOrganizationResponse,
    CreateUserForOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/user",
  });
};

/**
 * Get Organization Departments
 */
export const getOrganizationDepartments = <
  ThrowOnError extends boolean = false,
>(
  options: OptionsLegacyParser<GetOrganizationDepartmentsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOrganizationDepartmentsResponse,
    GetOrganizationDepartmentsError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/department",
  });
};

/**
 * Create Department
 */
export const createDepartment = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<CreateDepartmentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDepartmentResponse,
    CreateDepartmentError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/department",
  });
};

/**
 * Update Department
 */
export const updateDepartment = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateDepartmentData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateDepartmentResponse,
    UpdateDepartmentError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/department/{department_id}",
  });
};

/**
 * Remove User From Organization
 */
export const removeUserFromOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: OptionsLegacyParser<RemoveUserFromOrganizationData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    RemoveUserFromOrganizationResponse,
    RemoveUserFromOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/user/{user_id}",
  });
};

/**
 * Update User In Organization
 */
export const updateUserInOrganization = <ThrowOnError extends boolean = false>(
  options: OptionsLegacyParser<UpdateUserInOrganizationData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    UpdateUserInOrganizationResponse,
    UpdateUserInOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/user/{user_id}",
  });
};

/**
 * Invite User To Organization By Email
 */
export const inviteUserToOrganizationByEmail = <
  ThrowOnError extends boolean = false,
>(
  options: OptionsLegacyParser<
    InviteUserToOrganizationByEmailData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).put<
    InviteUserToOrganizationByEmailResponse,
    InviteUserToOrganizationByEmailError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/user/{user_email}",
  });
};

/**
 * Accept Invite User To Organization
 */
export const acceptInviteUserToOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: OptionsLegacyParser<
    AcceptInviteUserToOrganizationData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    AcceptInviteUserToOrganizationResponse,
    AcceptInviteUserToOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/invitation/accept",
  });
};

/**
 * Decline Invite User To Organization
 */
export const declineInviteUserToOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: OptionsLegacyParser<
    DeclineInviteUserToOrganizationData,
    ThrowOnError
  >,
) => {
  return (options?.client ?? client).post<
    DeclineInviteUserToOrganizationResponse,
    DeclineInviteUserToOrganizationError,
    ThrowOnError
  >({
    ...options,
    url: "/organization/{org_id}/invitation/decline",
  });
};

/**
 * Get Airbus Data
 */
export const getAirbusData = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<GetAirbusDataData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAirbusDataResponse,
    GetAirbusDataError,
    ThrowOnError
  >({
    ...options,
    url: "/airbus/preview",
  });
};

/**
 * Get Airbus Graphs
 */
export const getAirbusGraphs = <ThrowOnError extends boolean = false>(
  options?: OptionsLegacyParser<GetAirbusGraphsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAirbusGraphsResponse,
    GetAirbusGraphsError,
    ThrowOnError
  >({
    ...options,
    url: "/airbus/graphs",
  });
};
